var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIconVms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.523438 3.15625C0.523438 1.77554 1.64273 0.65625 3.02344 0.65625H17.0234C18.4042 0.65625 19.5234 1.77554 19.5234 3.15625V17.1562C19.5234 18.537 18.4042 19.6562 17.0234 19.6562H3.02344C1.64273 19.6562 0.523438 18.537 0.523438 17.1562V3.15625Z",
    fill: "white",
    stroke: "#BEBCBC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_70593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24211 16.0048L4.10295 12.9435C4.05202 12.8935 4.02344 12.826 4.02344 12.7555C4.02344 12.685 4.05202 12.6175 4.10295 12.5675L5.25936 11.4399C5.31058 11.3903 5.37983 11.3625 5.452 11.3625C5.52417 11.3625 5.59342 11.3903 5.64464 11.4399L7.51255 13.2617L15.2937 4.25001C15.3404 4.19661 15.4067 4.16328 15.4784 4.15724C15.55 4.1512 15.6212 4.17294 15.6766 4.21774L16.9273 5.24502C16.9821 5.29051 17.0162 5.3552 17.0224 5.42508C17.0286 5.49497 17.0063 5.56442 16.9604 5.61839L8.02226 15.9723C7.97497 16.0271 7.91653 16.0717 7.85065 16.1032C7.78476 16.1348 7.71287 16.1527 7.63952 16.1558C7.56617 16.1588 7.49297 16.147 7.42456 16.121C7.35615 16.095 7.29402 16.0555 7.24211 16.0048Z",
    fill: "#2563EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_70593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1503,
    height: 13.7143,
    fill: "white",
    transform: "translate(1.45312 3.01562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIconVms);
export default __webpack_public_path__ + "static/media/checked_icon_vms.20a9d65c2461bc465f156002114208c1.svg";
export { ForwardRef as ReactComponent };